<template>
  <section class="promises-items">
    <promises-item
      v-for="{ src, alt, headline, paragraphs } in items"
      :key="headline"
      :alt="alt"
      :src="src"
      :headline="headline"
      :paragraphs="paragraphs"
    />
  </section>
</template>

<script>
import PromisesItem from './PromisesItem.vue';

export default {
  components: {
    PromisesItem,
  },
  data() {
    return {
      items: [
        {
          headline: this.$t('promises.item-1.headline'),
          paragraphs: [this.$t('promises.item-1.paragraph')],
          src: 'img/icons/strongbox.svg',
          alt: this.$t('promises.item-1.iconAlt'),
        },
        {
          headline: this.$t('promises.item-2.headline'),
          paragraphs: [this.$t('promises.item-2.paragraph')],
          src: 'img/icons/lock.svg',
          alt: this.$t('promises.item-2.iconAlt'),
        },
        {
          headline: this.$t('promises.item-3.headline'),
          paragraphs: [
            this.$t('promises.item-3.paragraph-1'),
            this.$t('promises.item-3.paragraph-2'),
          ],
          src: 'img/icons/storage.svg',
          alt: this.$t('promises.item-3.iconAlt'),
        },
        {
          headline: this.$t('promises.item-4.headline'),
          paragraphs: [this.$t('promises.item-4.paragraph')],
          src: 'img/icons/change.svg',
          alt: this.$t('promises.item-4.iconAlt'),
        },
        {
          headline: this.$t('promises.item-5.headline'),
          paragraphs: [this.$t('promises.item-5.paragraph')],
          src: 'img/icons/target.svg',
          alt: this.$t('promises.item-5.iconAlt'),
        },
        {
          headline: this.$t('promises.item-6.headline'),
          paragraphs: [this.$t('promises.item-6.paragraph')],
          src: 'img/icons/revenue.svg',
          alt: this.$t('promises.item-6.iconAlt'),
        },
        {
          headline: this.$t('promises.item-7.headline'),
          paragraphs: [this.$t('promises.item-7.paragraph')],
          src: 'img/icons/clickingPalm.svg',
          alt: this.$t('promises.item-7.iconAlt'),
        },
      ],
    };
  },
};
</script>

<style lang="scss" stuled>
@import '~@/assets/styles/variables';
@import '~@/assets/styles/breakpoints';

.promises-items {
  max-width: $page-container-width;
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 70px;
}

@media (max-width: $page-table-breakpoint) {
  .promises-items {
    justify-content: center;
  }
}
</style>
